import { render, staticRenderFns } from "./V2Modal.vue?vue&type=template&id=458c1b10&scoped=true&"
import script from "./V2Modal.vue?vue&type=script&lang=js&"
export * from "./V2Modal.vue?vue&type=script&lang=js&"
import style0 from "./V2Modal.vue?vue&type=style&index=0&id=458c1b10&lang=scss&scoped=true&"
import style1 from "./V2Modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c1b10",
  null
  
)

export default component.exports